// src/pages/Configuracion.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../services/api";
import Swal from "sweetalert2";


const Configuracion = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);

  // Cargar configuración actual
  useEffect(() => {
    cargarConfiguracion();
  }, []);

  const cargarConfiguracion = async () => {
    try {
      setLoading(true);
      const res = await api.get("/configuracion");
      setConfig(res.data);
    } catch (error) {
      console.error("Error al cargar configuración:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo cargar la configuración",
      });
    } finally {
      setLoading(false);
    }
  };

 const toggleModulo = async (modulo) => {
  try {
    const activar = !config[modulo];
    
    // Mapeo de nombres de módulos
    const nombreModulos = {
      modulo_pos: "POS",
      modulo_oficina: "Oficina",
      modulo_proyectos: "Proyectos",
      modulo_almacenes_multiple: "Almacenes Múltiples",
      modulo_transferencias: "Transferencias",
      modulo_prestamos: "Préstamos",
      modulo_rentacar: "RentaCar",
      modulo_control_financiero: "Control Financiero",
      modulo_facturacion: "Facturación",
      modulo_ncf: "Comprobantes Fiscales (NCF)",
      modulo_crm: "CRM Comercial",
      modulo_ecf: "e-CF (Facturación Electrónica)",
      modulo_contabilidad: "Contabilidad",
      modulo_migracion: "Migración de Datos",
      modulo_ordenes_compra: "Órdenes de Compra",
      modulo_email_marketing: "Email Marketing",
    };
    
    // Mapeo correcto de rutas API
    const rutasAPI = {
      modulo_oficina: "toggle-oficina",
      modulo_pos: "toggle-pos",
      modulo_proyectos: "toggle-proyectos",
      modulo_almacenes_multiple: "toggle-almacenes",
      modulo_transferencias: "toggle-transferencias",
      modulo_prestamos: "toggle-prestamos",
      modulo_rentacar: "modulos/rentacar/toggle",
      modulo_control_financiero: "toggle-control-financiero",
      modulo_facturacion: "toggle-facturacion",
      modulo_ncf: "toggle-ncf",
      modulo_crm: "toggle-crm",
      modulo_ecf: "toggle-ecf",
      modulo_contabilidad: "toggle-contabilidad",
      modulo_migracion: "toggle-migracion",
      modulo_ordenes_compra: "toggle-ordenes-compra",
      modulo_email_marketing: "toggle-email-marketing",
    };
    
    const result = await Swal.fire({
      icon: "question",
      title: activar ? "Activar Módulo" : "Desactivar Módulo",
      html: `
        <p>¿Estás seguro de ${activar ? "activar" : "desactivar"} el módulo <strong>${nombreModulos[modulo]}</strong>?</p>
        ${activar 
          ? '<p style="color: #059669; font-size: 14px;">✅ Los usuarios tendrán acceso a las funciones de este módulo</p>' 
          : '<p style="color: #dc2626; font-size: 14px;">⚠️ Los usuarios NO podrán acceder a las funciones de este módulo</p>'
        }
      `,
      showCancelButton: true,
      confirmButtonColor: activar ? "#10b981" : "#ef4444",
      cancelButtonColor: "#64748b",
      confirmButtonText: activar ? "Sí, activar" : "Sí, desactivar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    setGuardando(true);

    const ruta = rutasAPI[modulo];
    if (!ruta) {
      throw new Error(`Ruta no encontrada para el módulo: ${modulo}`);
    }

    await api.post(`/configuracion/${ruta}`, { activar });

    await cargarConfiguracion();

    Swal.fire({
      icon: "success",
      title: activar ? "Módulo Activado" : "Módulo Desactivado",
      text: `El módulo ${nombreModulos[modulo]} ha sido ${activar ? "activado" : "desactivado"} correctamente`,
      timer: 2000,
      showConfirmButton: false,
    });
  } catch (error) {
    console.error("Error al cambiar módulo:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.response?.data?.mensaje || error.message || "No se pudo cambiar el módulo",
    });
  } finally {
    setGuardando(false);
  }
};

const guardarConfiguracion = async () => {
  try {
    setGuardando(true);

    await api.put("/configuracion", config);

    Swal.fire({
      icon: "success",
      title: "Configuración Guardada",
      text: "Los cambios se guardaron correctamente",
      timer: 2000,
      showConfirmButton: false,
    });
  } catch (error) {
    console.error("Error al guardar configuración:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo guardar la configuración",
    });
  } finally {
    setGuardando(false);
  }
};

  const handleChange = (field, value) => {
    setConfig({ ...config, [field]: value });
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loading}>Cargando configuración...</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.title}>⚙️ Configuración del Sistema</h1>
        <p style={styles.subtitle}>
          Administra los módulos y configuración general
        </p>
      </div>

      {/* Módulos */}
      <div style={styles.card}>
        <h2 style={styles.cardTitle}>📦 Módulos del Sistema</h2>
        <p style={styles.cardSubtitle}>
          Activa o desactiva módulos según las necesidades de tu negocio
        </p>

        <div style={styles.modulosGrid}>
          {/* Módulo Oficina */}
          <div
            style={{
              ...styles.moduloCard,
              borderColor: config?.modulo_oficina ? "#10b981" : "#e2e8f0",
              background: config?.modulo_oficina ? "#f0fdf4" : "white",
            }}
          >
            <div style={styles.moduloHeader}>
              <div style={styles.moduloIcon}>🏢</div>
              <div>
                <h3 style={styles.moduloTitulo}>Módulo Oficina</h3>
                <p style={styles.moduloDescripcion}>
                  Requisiciones, entradas, salidas y control de inventario
                </p>
              </div>
            </div>

            <div style={styles.moduloEstado}>
              <span
                style={{
                  ...styles.estadoBadge,
                  background: config?.modulo_oficina ? "#d1fae5" : "#fee2e2",
                  color: config?.modulo_oficina ? "#065f46" : "#991b1b",
                }}
              >
                {config?.modulo_oficina ? "✅ Activo" : "❌ Inactivo"}
              </span>
            </div>

            <button
              style={{
                ...styles.btnToggle,
                background: config?.modulo_oficina ? "#ef4444" : "#10b981",
              }}
              onClick={() => toggleModulo("modulo_oficina")}
              disabled={guardando}
            >
              {config?.modulo_oficina ? "Desactivar" : "Activar"}
            </button>
          </div>

          {/* Módulo POS */}
          <div
            style={{
              ...styles.moduloCard,
              borderColor: config?.modulo_pos ? "#10b981" : "#e2e8f0",
              background: config?.modulo_pos ? "#f0fdf4" : "white",
            }}
          >
            <div style={styles.moduloHeader}>
              <div style={styles.moduloIcon}>🛒</div>
              <div>
                <h3 style={styles.moduloTitulo}>Módulo POS</h3>
                <p style={styles.moduloDescripcion}>
                  Punto de venta, clientes, facturación y reportes de ventas
                </p>
              </div>
            </div>

            <div style={styles.moduloEstado}>
              <span
                style={{
                  ...styles.estadoBadge,
                  background: config?.modulo_pos ? "#d1fae5" : "#fee2e2",
                  color: config?.modulo_pos ? "#065f46" : "#991b1b",
                }}
              >
                {config?.modulo_pos ? "✅ Activo" : "❌ Inactivo"}
              </span>
            </div>

            <button
              style={{
                ...styles.btnToggle,
                background: config?.modulo_pos ? "#ef4444" : "#10b981",
              }}
              onClick={() => toggleModulo("modulo_pos")}
              disabled={guardando}
            >
              {config?.modulo_pos ? "Desactivar" : "Activar"}
            </button>
          </div>
        </div>
      </div>
      {/* ========================================== */}
{/* MÓDULO CRM - COMERCIAL */}
{/* ========================================== */}
<div
  style={{
    ...styles.moduloCard,
    borderColor: config?.modulo_crm ? "#667eea" : "#e2e8f0",
    background: config?.modulo_crm ? "#f0f7ff" : "white",
  }}
>
  <div style={styles.moduloHeader}>
    <div style={styles.moduloIcon}>📞</div>
    <div>
      <h3 style={styles.moduloTitulo}>CRM Comercial</h3>
      <p style={styles.moduloDescripcion}>
        Gestión de prospectos, oportunidades y cierre de ventas
      </p>
    </div>
  </div>

  <div style={styles.moduloEstado}>
    <span
      style={{
        ...styles.estadoBadge,
        background: config?.modulo_crm ? "#e0e7ff" : "#fee2e2",
        color: config?.modulo_crm ? "#4f46e5" : "#991b1b",
      }}
    >
      {config?.modulo_crm ? "✅ Activo" : "❌ Inactivo"}
    </span>
  </div>

  <button
    style={{
      ...styles.btnToggle,
      background: config?.modulo_crm ? "#ef4444" : "#667eea",
    }}
    onClick={() => toggleModulo("modulo_crm")}
    disabled={guardando}
  >
    {config?.modulo_crm ? "Desactivar" : "Activar"}
  </button>
</div>

      {/* Configuración POS */}
      {config?.modulo_pos && (
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>🛒 Configuración del POS</h2>

          <div style={styles.formGrid}>
            {/* ITBIS */}
            <div style={styles.formGroup}>
              <label style={styles.label}>
                <input
                  type="checkbox"
                  checked={config.pos_itbis_activo}
                  onChange={(e) =>
                    handleChange("pos_itbis_activo", e.target.checked)
                  }
                  style={styles.checkbox}
                />
                Aplicar {config?.fiscal?.impuesto_label || 'ITBIS'} en ventas
              </label>
            </div>

            {config.pos_itbis_activo && (
              <div style={styles.formGroup}>
                <label style={styles.label}>Porcentaje de {config?.fiscal?.impuesto_label || 'ITBIS'} (%)</label>
                <input
                  type="number"
                  step="0.01"
                  value={config.pos_itbis_porcentaje}
                  onChange={(e) =>
                    handleChange("pos_itbis_porcentaje", e.target.value)
                  }
                  style={styles.input}
                />
              </div>
            )}

            {/* Descuentos */}
            <div style={styles.formGroup}>
              <label style={styles.label}>
                <input
                  type="checkbox"
                  checked={config.pos_permite_descuentos}
                  onChange={(e) =>
                    handleChange("pos_permite_descuentos", e.target.checked)
                  }
                  style={styles.checkbox}
                />
                Permitir descuentos
              </label>
            </div>

            {config.pos_permite_descuentos && (
              <div style={styles.formGroup}>
                <label style={styles.label}>Descuento máximo (%)</label>
                <input
                  type="number"
                  step="0.01"
                  value={config.pos_descuento_maximo}
                  onChange={(e) =>
                    handleChange("pos_descuento_maximo", e.target.value)
                  }
                  style={styles.input}
                />
              </div>
            )}

            {/* Otras opciones */}
            <div style={styles.formGroup}>
              <label style={styles.label}>
                <input
                  type="checkbox"
                  checked={config.pos_requiere_cliente}
                  onChange={(e) =>
                    handleChange("pos_requiere_cliente", e.target.checked)
                  }
                  style={styles.checkbox}
                />
                Requerir cliente en cada venta
              </label>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>
                <input
                  type="checkbox"
                  checked={config.pos_imprime_ticket}
                  onChange={(e) =>
                    handleChange("pos_imprime_ticket", e.target.checked)
                  }
                  style={styles.checkbox}
                />
                Imprimir ticket automáticamente
              </label>
            </div>

            {/* Terminal de pago */}
            <div style={{...styles.formGroup, gridColumn:"1/-1", borderTop:"1px solid #e2e8f0", paddingTop:"16px", marginTop:"4px"}}>
              <label style={{...styles.label, fontWeight:"600", fontSize:"13px"}}>📡 Terminal de pago (Datafono)</label>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Marca del terminal</label>
              <select
                value={config.terminal_tipo || "ninguno"}
                onChange={(e) => handleChange("terminal_tipo", e.target.value)}
                style={styles.input}
              >
                <option value="ninguno">Sin terminal integrado</option>
                <option value="verifone">Verifone</option>
                <option value="pax">PAX</option>
                <option value="ingenico">Ingenico</option>
              </select>
            </div>
            {config.terminal_tipo && config.terminal_tipo !== "ninguno" && (
              <>
                <div style={styles.formGroup}>
                  <label style={styles.label}>IP del terminal</label>
                  <input
                    type="text"
                    value={config.terminal_ip || ""}
                    onChange={(e) => handleChange("terminal_ip", e.target.value)}
                    style={styles.input}
                    placeholder="192.168.1.50"
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Puerto</label>
                  <input
                    type="number"
                    value={config.terminal_puerto || 8888}
                    onChange={(e) => handleChange("terminal_puerto", parseInt(e.target.value))}
                    style={styles.input}
                    placeholder="8888"
                  />
                </div>
                <div style={{...styles.formGroup, gridColumn:"1/-1"}}>
                  <p style={{fontSize:"11px", color:"#64748b", margin:0}}>
                    ⚠️ Requiere el agente local <strong>eFit Terminal Agent</strong> instalado en la PC del cajero.
                    El agente escucha en <code>localhost:7070</code> y se comunica con el terminal en la red local.
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Configuración Nómina */}
      <div style={styles.card}>
        <h2 style={styles.cardTitle}>💰 Configuración de Nómina</h2>
        <div style={styles.formGrid}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Quincena de descuento TSS e ISR</label>
            <select
              value={config?.nomina_quincena_descuento || 'primera'}
              onChange={(e) => handleChange('nomina_quincena_descuento', e.target.value)}
              style={styles.input}
            >
              <option value="primera">Primera quincena (1-15)</option>
              <option value="segunda">Segunda quincena (16-fin de mes)</option>
            </select>
            <p style={{ fontSize: '12px', color: '#64748b', margin: '6px 0 0 0' }}>
              Define en qué quincena se aplican las retenciones de SFS, AFP e ISR al procesar nómina quincenal.
              La quincena opuesta se procesa sin descuentos.
            </p>
          </div>
        </div>
      </div>

{/* Módulos Constructora */}
<div style={styles.card}>
  <h2 style={styles.cardTitle}>🏗️ Módulos de Constructora</h2>
  <p style={styles.cardSubtitle}>
    Sistema avanzado de gestión de almacenes, transferencias y préstamos
  </p>

  <div style={styles.modulosGrid}>
    {/* Módulo Proyectos */}
    <div
      style={{
        ...styles.moduloCard,
        borderColor: config?.modulo_proyectos ? "#3b82f6" : "#e2e8f0",
        background: config?.modulo_proyectos ? "#eff6ff" : "white",
      }}
    >
      <div style={styles.moduloHeader}>
        <div style={styles.moduloIcon}>🏗️</div>
        <div>
          <h3 style={styles.moduloTitulo}>Proyectos</h3>
          <p style={styles.moduloDescripcion}>
            Gestión de proyectos y presupuestos
          </p>
        </div>
      </div>

      <div style={styles.moduloEstado}>
        <span
          style={{
            ...styles.estadoBadge,
            background: config?.modulo_proyectos ? "#dbeafe" : "#fee2e2",
            color: config?.modulo_proyectos ? "#1e40af" : "#991b1b",
          }}
        >
          {config?.modulo_proyectos ? "✅ Activo" : "❌ Inactivo"}
        </span>
      </div>

      <button
        style={{
          ...styles.btnToggle,
          background: config?.modulo_proyectos ? "#ef4444" : "#3b82f6",
        }}
        onClick={() => toggleModulo("modulo_proyectos")}
        disabled={guardando}
      >
        {config?.modulo_proyectos ? "Desactivar" : "Activar"}
      </button>
    </div>

   {/* Control Financiero de Proyectos */}
<div
  style={{
    ...styles.moduloCard,
    borderColor: config?.modulo_control_financiero ? "#8b5cf6" : "#e2e8f0",
    background: config?.modulo_control_financiero ? "#faf5ff" : "white",
  }}
>
  <div style={styles.moduloHeader}>
    <div style={styles.moduloIcon}>💼</div>
    <div>
      <h3 style={styles.moduloTitulo}>Control Financiero de Proyectos</h3>
      <p style={styles.moduloDescripcion}>
        Gestión de costos, nómina, gastos y rentabilidad por proyecto
      </p>
    </div>
  </div>

  <div style={styles.moduloEstado}>
    <span
      style={{
        ...styles.estadoBadge,
        background: config?.modulo_control_financiero ? "#f3e8ff" : "#fee2e2",
        color: config?.modulo_control_financiero ? "#6b21a8" : "#991b1b",
      }}
    >
      {config?.modulo_control_financiero ? "✅ Activo" : "❌ Inactivo"}
    </span>
  </div>

  <button
    style={{
      ...styles.btnToggle,
      background: config?.modulo_control_financiero ? "#ef4444" : "#8b5cf6",
    }}
    onClick={() => toggleModulo("modulo_control_financiero")}
    disabled={guardando}
  >
    {config?.modulo_control_financiero ? "Desactivar" : "Activar"}
  </button>
</div>

    {/* Módulo Almacenes Múltiples */}
    <div
      style={{
        ...styles.moduloCard,
        borderColor: config?.modulo_almacenes_multiple ? "#3b82f6" : "#e2e8f0",
        background: config?.modulo_almacenes_multiple ? "#eff6ff" : "white",
      }}
    >
      <div style={styles.moduloHeader}>
        <div style={styles.moduloIcon}>🏢</div>
        <div>
          <h3 style={styles.moduloTitulo}>Almacenes Múltiples</h3>
          <p style={styles.moduloDescripcion}>
            Gestión de almacenes principal y secundarios
          </p>
        </div>
      </div>

      <div style={styles.moduloEstado}>
        <span
          style={{
            ...styles.estadoBadge,
            background: config?.modulo_almacenes_multiple ? "#dbeafe" : "#fee2e2",
            color: config?.modulo_almacenes_multiple ? "#1e40af" : "#991b1b",
          }}
        >
          {config?.modulo_almacenes_multiple ? "✅ Activo" : "❌ Inactivo"}
        </span>
      </div>

      <button
        style={{
          ...styles.btnToggle,
          background: config?.modulo_almacenes_multiple ? "#ef4444" : "#3b82f6",
        }}
        onClick={() => toggleModulo("modulo_almacenes_multiple")}
        disabled={guardando}
      >
        {config?.modulo_almacenes_multiple ? "Desactivar" : "Activar"}
      </button>
    </div>

    {/* Módulo Transferencias */}
    <div
      style={{
        ...styles.moduloCard,
        borderColor: config?.modulo_transferencias ? "#3b82f6" : "#e2e8f0",
        background: config?.modulo_transferencias ? "#eff6ff" : "white",
      }}
    >
      <div style={styles.moduloHeader}>
        <div style={styles.moduloIcon}>🔄</div>
        <div>
          <h3 style={styles.moduloTitulo}>Transferencias</h3>
          <p style={styles.moduloDescripcion}>
            Movimientos entre almacenes con aprobación
          </p>
        </div>
      </div>

      <div style={styles.moduloEstado}>
        <span
          style={{
            ...styles.estadoBadge,
            background: config?.modulo_transferencias ? "#dbeafe" : "#fee2e2",
            color: config?.modulo_transferencias ? "#1e40af" : "#991b1b",
          }}
        >
          {config?.modulo_transferencias ? "✅ Activo" : "❌ Inactivo"}
        </span>
      </div>

      <button
        style={{
          ...styles.btnToggle,
          background: config?.modulo_transferencias ? "#ef4444" : "#3b82f6",
        }}
        onClick={() => toggleModulo("modulo_transferencias")}
        disabled={guardando}
      >
        {config?.modulo_transferencias ? "Desactivar" : "Activar"}
      </button>
    </div>

    {/* Módulo Préstamos */}
    <div
      style={{
        ...styles.moduloCard,
        borderColor: config?.modulo_prestamos ? "#3b82f6" : "#e2e8f0",
        background: config?.modulo_prestamos ? "#eff6ff" : "white",
      }}
    >
      <div style={styles.moduloHeader}>
        <div style={styles.moduloIcon}>🤝</div>
        <div>
          <h3 style={styles.moduloTitulo}>Préstamos</h3>
          <p style={styles.moduloDescripcion}>
            Préstamos de materiales entre proyectos
          </p>
        </div>
      </div>

      <div style={styles.moduloEstado}>
        <span
          style={{
            ...styles.estadoBadge,
            background: config?.modulo_prestamos ? "#dbeafe" : "#fee2e2",
            color: config?.modulo_prestamos ? "#1e40af" : "#991b1b",
          }}
        >
          {config?.modulo_prestamos ? "✅ Activo" : "❌ Inactivo"}
        </span>
      </div>

      <button
        style={{
          ...styles.btnToggle,
          background: config?.modulo_prestamos ? "#ef4444" : "#3b82f6",
        }}
        onClick={() => toggleModulo("modulo_prestamos")}
        disabled={guardando}
      >
        {config?.modulo_prestamos ? "Desactivar" : "Activar"}
      </button>
    </div>
  </div>
</div>
{/* Módulo RentaCar */}
    <div
      style={{
        ...styles.moduloCard,
        borderColor: config?.modulo_rentacar ? "#1e40af" : "#e2e8f0",
        background: config?.modulo_rentacar ? "#f0f7ff" : "white",
      }}
    >
      <div style={styles.moduloHeader}>
        <div style={styles.moduloIcon}>🚗</div>
        <div>
          <h3 style={styles.moduloTitulo}>RentaCar</h3>
          <p style={styles.moduloDescripcion}>
            Sistema de renta de vehículos y gestión de flota
          </p>
        </div>
      </div>

      <div style={styles.moduloEstado}>
        <span
          style={{
            ...styles.estadoBadge,
            background: config?.modulo_rentacar ? "#dbeafe" : "#fee2e2",
            color: config?.modulo_rentacar ? "#1e40af" : "#991b1b",
          }}
        >
          {config?.modulo_rentacar ? "✅ Activo" : "❌ Inactivo"}
        </span>
      </div>

      <button
        style={{
          ...styles.btnToggle,
          background: config?.modulo_rentacar ? "#ef4444" : "#1e40af",
        }}
        onClick={() => toggleModulo("modulo_rentacar")}
        disabled={guardando}
      >
        {config?.modulo_rentacar ? "Desactivar" : "Activar"}
      </button>
    </div>

    {/* Módulo Facturación */}
<div
  style={{
    ...styles.moduloCard,
    borderColor: config?.modulo_facturacion ? "#8b5cf6" : "#e2e8f0",
    background: config?.modulo_facturacion ? "#faf5ff" : "white",
  }}
>
  <div style={styles.moduloHeader}>
    <div style={styles.moduloIcon}>🧾</div>
    <div>
      <h3 style={styles.moduloTitulo}>Facturación + Cuentas por Cobrar</h3>
      <p style={styles.moduloDescripcion}>
        Facturación de proyectos, gestión de pagos y cuentas por cobrar
      </p>
    </div>
  </div>

  <div style={styles.moduloEstado}>
    <span
      style={{
        ...styles.estadoBadge,
        background: config?.modulo_facturacion ? "#ede9fe" : "#fee2e2",
        color: config?.modulo_facturacion ? "#6b21a8" : "#991b1b",
      }}
    >
      {config?.modulo_facturacion ? "✅ Activo" : "❌ Inactivo"}
    </span>
  </div>

  <button
    style={{
      ...styles.btnToggle,
      background: config?.modulo_facturacion ? "#ef4444" : "#8b5cf6",
    }}
    onClick={() => toggleModulo("modulo_facturacion")}
    disabled={guardando}
  >
    {config?.modulo_facturacion ? "Desactivar" : "Activar"}
  </button>
</div>
{/* Módulo NCF */}
<div
  style={{
    ...styles.moduloCard,
    borderColor: config?.modulo_ncf ? "#f59e0b" : "#e2e8f0",
    background: config?.modulo_ncf ? "#fffbeb" : "white",
  }}
>
  <div style={styles.moduloHeader}>
    <div style={styles.moduloIcon}>📋</div>
    <div>
      <h3 style={styles.moduloTitulo}>Comprobantes Fiscales (NCF)</h3>
      <p style={styles.moduloDescripcion}>
        Gestión de secuencias NCF para facturación fiscal
      </p>
    </div>
  </div>

  <div style={styles.moduloEstado}>
    <span
      style={{
        ...styles.estadoBadge,
        background: config?.modulo_ncf ? "#fef3c7" : "#fee2e2",
        color: config?.modulo_ncf ? "#92400e" : "#991b1b",
      }}
    >
      {config?.modulo_ncf ? "✅ Activo" : "❌ Inactivo"}
    </span>
  </div>

  <button
    style={{
      ...styles.btnToggle,
      background: config?.modulo_ncf ? "#ef4444" : "#f59e0b",
    }}
    onClick={() => toggleModulo("modulo_ncf")}
    disabled={guardando}
  >
    {config?.modulo_ncf ? "Desactivar" : "Activar"}
  </button>
</div>
 

      {/* Módulo e-CF */}
      <div
        style={{
          ...styles.moduloCard,
          borderColor: config?.modulo_ecf ? '#0066cc' : '#e2e8f0',
          background: config?.modulo_ecf ? '#f0f7ff' : 'white',
        }}
      >
        <div style={styles.moduloHeader}>
          <div style={styles.moduloIcon}>📡</div>
          <div>
            <h3 style={styles.moduloTitulo}>Comprobantes Fiscales Electrónicos (e-CF)</h3>
            <p style={styles.moduloDescripcion}>
              Envío de e-CF a la DGII vía Alanube — facturación electrónica obligatoria RD
            </p>
          </div>
        </div>
        <div style={styles.moduloEstado}>
          <span
            style={{
              ...styles.estadoBadge,
              background: config?.modulo_ecf ? '#dbeafe' : '#fee2e2',
              color: config?.modulo_ecf ? '#1d4ed8' : '#991b1b',
            }}
          >
            {config?.modulo_ecf ? '✅ Activo' : '❌ Inactivo'}
          </span>
          {config?.modulo_ecf && (
            <Link
              to="/configuracion/ecf"
              style={{ marginLeft: '8px', padding: '3px 10px', fontSize: '12px', background: '#0066cc', color: '#fff', borderRadius: '12px', textDecoration: 'none', fontWeight: '600' }}
            >
              ⚙️ Configurar
            </Link>
          )}
        </div>
        <button
          style={{ ...styles.btnToggle, background: config?.modulo_ecf ? '#ef4444' : '#0066cc' }}
          onClick={() => toggleModulo('modulo_ecf')}
          disabled={guardando}
        >
          {config?.modulo_ecf ? 'Desactivar' : 'Activar'}
        </button>
      </div>

      {/* Módulo Contabilidad */}
      <div
        style={{
          ...styles.moduloCard,
          borderColor: config?.modulo_contabilidad ? '#1e3a8a' : '#e2e8f0',
          background: config?.modulo_contabilidad ? '#f0f4ff' : 'white',
        }}
      >
        <div style={styles.moduloHeader}>
          <div style={styles.moduloIcon}>📒</div>
          <div>
            <h3 style={styles.moduloTitulo}>Módulo Contabilidad</h3>
            <p style={styles.moduloDescripcion}>
              Plan de cuentas, asientos doble entrada, cuentas por pagar, reportes DGII 606/607/608 y notas de crédito/débito
            </p>
          </div>
        </div>
        <div style={styles.moduloEstado}>
          <span
            style={{
              ...styles.estadoBadge,
              background: config?.modulo_contabilidad ? '#dbeafe' : '#fee2e2',
              color: config?.modulo_contabilidad ? '#1d4ed8' : '#991b1b',
            }}
          >
            {config?.modulo_contabilidad ? '✅ Activo' : '❌ Inactivo'}
          </span>
          {config?.modulo_contabilidad && (
            <Link to="/contabilidad" style={{ marginLeft: '8px', padding: '3px 10px', fontSize: '12px', background: '#1e3a8a', color: '#fff', borderRadius: '12px', textDecoration: 'none', fontWeight: '600' }}>
              Abrir
            </Link>
          )}
        </div>
        <button
          style={{ ...styles.btnToggle, background: config?.modulo_contabilidad ? '#ef4444' : '#1e3a8a' }}
          onClick={() => toggleModulo('modulo_contabilidad')}
          disabled={guardando}
        >
          {config?.modulo_contabilidad ? 'Desactivar' : 'Activar'}
        </button>
      </div>

      {/* Accesos Rápidos Contables */}
      <div style={{ ...styles.card, background: 'linear-gradient(135deg, #1e3a8a11, #3b82f611)', borderColor: '#1e3a8a33' }}>
        <h2 style={styles.cardTitle}>📒 Módulo Contable</h2>
        <p style={{ color: '#64748b', fontSize: '0.9rem', margin: '0 0 1rem' }}>Accede a los módulos contables del sistema</p>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          {[
            { href: '/contabilidad',      label: '📒 Plan de Cuentas & Asientos', color: '#1e3a8a' },
            { href: '/bancos',            label: '🏦 Bancos & Tesorería',          color: '#0891b2' },
            { href: '/dgii/reportes',     label: '🏛 Reportes DGII (606/607/608)', color: '#7c3aed' },
            { href: '/notas',             label: '📝 Notas de Crédito/Débito',     color: '#059669' },
            { href: '/cuentas-pagar',     label: '💳 Cuentas por Pagar (AP)',      color: '#dc2626' },
            { href: '/empleados',         label: '👷 Empleados',                    color: '#475569' },
            { href: '/nomina',            label: '💰 Nómina Universal',             color: '#0f766e' },
            { href: '/activos-fijos',     label: '🏗 Activos Fijos',               color: '#b45309' },
            { href: '/empresas-contables',label: '🏢 Empresas Contables',          color: '#1e3a5f' },
            { href: '/manual',            label: '📖 Manual de Usuario',           color: '#0369a1' },
          ].map(a => (
            <Link key={a.href} to={a.href} style={{ padding: '0.5rem 1rem', background: a.color, color: '#fff', borderRadius: 6, textDecoration: 'none', fontWeight: 600, fontSize: '0.875rem' }}>
              {a.label}
            </Link>
          ))}
        </div>
      </div>

      {/* Módulo Migración */}
      <div
        style={{
          ...styles.moduloCard,
          borderColor: config?.modulo_migracion ? '#16a34a' : '#e2e8f0',
          background: config?.modulo_migracion ? '#f0fdf4' : 'white',
        }}
      >
        <div style={styles.moduloHeader}>
          <div style={styles.moduloIcon}>📥</div>
          <div>
            <h3 style={styles.moduloTitulo}>Módulo Migración de Datos</h3>
            <p style={styles.moduloDescripcion}>
              Importa clientes, proveedores, productos y plan de cuentas desde QuickBooks, Xero, SAP, Odoo, SAINT, Contpaq y más.
            </p>
          </div>
        </div>
        <div style={styles.moduloEstado}>
          <span
            style={{
              ...styles.estadoBadge,
              background: config?.modulo_migracion ? '#dcfce7' : '#fee2e2',
              color: config?.modulo_migracion ? '#166534' : '#991b1b',
            }}
          >
            {config?.modulo_migracion ? '✅ Activo' : '❌ Inactivo'}
          </span>
          {config?.modulo_migracion && (
            <Link to="/migracion" style={{ marginLeft: '8px', padding: '3px 10px', fontSize: '12px', background: '#16a34a', color: '#fff', borderRadius: '12px', textDecoration: 'none', fontWeight: '600' }}>
              Abrir
            </Link>
          )}
        </div>
        <button
          style={{ ...styles.btnToggle, background: config?.modulo_migracion ? '#ef4444' : '#16a34a' }}
          onClick={() => toggleModulo('modulo_migracion')}
          disabled={guardando}
        >
          {config?.modulo_migracion ? 'Desactivar' : 'Activar'}
        </button>
      </div>

      {/* Módulo Órdenes de Compra */}
      <div
        style={{
          ...styles.moduloCard,
          borderColor: config?.modulo_ordenes_compra ? '#d97706' : '#e2e8f0',
          background: config?.modulo_ordenes_compra ? '#fffbeb' : 'white',
        }}
      >
        <div style={styles.moduloHeader}>
          <div style={styles.moduloIcon}>🛒</div>
          <div>
            <h3 style={styles.moduloTitulo}>Módulo Órdenes de Compra</h3>
            <p style={styles.moduloDescripcion}>
              Gestión de proveedores, órdenes de compra, recepción de mercancía y asientos contables automáticos.
            </p>
          </div>
        </div>
        <div style={styles.moduloEstado}>
          <span style={{
            ...styles.estadoBadge,
            background: config?.modulo_ordenes_compra ? '#fef3c7' : '#fee2e2',
            color: config?.modulo_ordenes_compra ? '#92400e' : '#991b1b',
          }}>
            {config?.modulo_ordenes_compra ? '✅ Activo' : '❌ Inactivo'}
          </span>
          {config?.modulo_ordenes_compra && (
            <Link to="/ordenes-compra" style={styles.btnAbrir}>Abrir</Link>
          )}
        </div>
        <button
          style={{ ...styles.btnToggle, background: config?.modulo_ordenes_compra ? '#ef4444' : '#d97706' }}
          onClick={() => toggleModulo('modulo_ordenes_compra')}
          disabled={guardando}
        >
          {config?.modulo_ordenes_compra ? 'Desactivar' : 'Activar'}
        </button>
      </div>

      {/* Módulo Email Marketing */}
      <div
        style={{
          ...styles.moduloCard,
          borderColor: config?.modulo_email_marketing ? '#0f766e' : '#e2e8f0',
          background: config?.modulo_email_marketing ? '#f0fdfa' : 'white',
        }}
      >
        <div style={styles.moduloHeader}>
          <div style={styles.moduloIcon}>📧</div>
          <div>
            <h3 style={styles.moduloTitulo}>Módulo Email Marketing</h3>
            <p style={styles.moduloDescripcion}>
              Crea campañas de correo masivo, diseña plantillas reutilizables y administra listas de contactos segmentadas.
            </p>
          </div>
        </div>
        <div style={styles.moduloEstado}>
          <span style={{
            ...styles.estadoBadge,
            background: config?.modulo_email_marketing ? '#ccfbf1' : '#fee2e2',
            color: config?.modulo_email_marketing ? '#134e4a' : '#991b1b',
          }}>
            {config?.modulo_email_marketing ? '✅ Activo' : '❌ Inactivo'}
          </span>
          {config?.modulo_email_marketing && (
            <Link to="/email" style={{ ...styles.btnAbrir, background: '#0f766e' }}>Abrir</Link>
          )}
        </div>
        <button
          style={{ ...styles.btnToggle, background: config?.modulo_email_marketing ? '#ef4444' : '#0f766e' }}
          onClick={() => toggleModulo('modulo_email_marketing')}
          disabled={guardando}
        >
          {config?.modulo_email_marketing ? 'Desactivar' : 'Activar'}
        </button>
      </div>

      {/* Datos de la Empresa */}
      <div style={styles.card}>
        <h2 style={styles.cardTitle}>🏢 Datos de la Empresa</h2>

        <div style={styles.formGrid}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Nombre de la Empresa *</label>
            <input
              type="text"
              value={config?.empresa_nombre || ""}
              onChange={(e) => handleChange("empresa_nombre", e.target.value)}
              style={styles.input}
              placeholder="Mi Empresa S.A."
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>RNC</label>
            <input
              type="text"
              value={config?.empresa_rnc || ""}
              onChange={(e) => handleChange("empresa_rnc", e.target.value)}
              style={styles.input}
              placeholder="000-00000-0"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Teléfono</label>
            <input
              type="text"
              value={config?.empresa_telefono || ""}
              onChange={(e) => handleChange("empresa_telefono", e.target.value)}
              style={styles.input}
              placeholder="809-000-0000"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              value={config?.empresa_email || ""}
              onChange={(e) => handleChange("empresa_email", e.target.value)}
              style={styles.input}
              placeholder="contacto@miempresa.com"
            />
          </div>

          <div style={{ ...styles.formGroup, gridColumn: "1 / -1" }}>
            <label style={styles.label}>Dirección</label>
            <textarea
              value={config?.empresa_direccion || ""}
              onChange={(e) =>
                handleChange("empresa_direccion", e.target.value)
              }
              style={{ ...styles.input, minHeight: "80px", resize: "vertical" }}
              placeholder="Calle Principal #123, Ciudad, País"
            />
          </div>
        </div>
      </div>

      {/* Botón Guardar */}
      <div style={styles.actions}>
        <button
          style={{
            ...styles.btnGuardar,
            opacity: guardando ? 0.6 : 1,
            cursor: guardando ? "not-allowed" : "pointer",
          }}
          onClick={guardarConfiguracion}
          disabled={guardando}
        >
          {guardando ? "Guardando..." : "💾 Guardar Configuración"}
        </button>
      </div>

    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    background: "#f8fafc",
    padding: "20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    marginBottom: "25px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0 0 5px 0",
  },
  subtitle: {
    fontSize: "14px",
    color: "#64748b",
    margin: "0",
  },
  loading: {
    textAlign: "center",
    padding: "40px",
    fontSize: "16px",
    color: "#64748b",
  },
  card: {
    background: "white",
    borderRadius: "12px",
    padding: "25px",
    marginBottom: "20px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    border: "1px solid #e2e8f0",
  },
  cardTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0 0 8px 0",
  },
  cardSubtitle: {
    fontSize: "14px",
    color: "#64748b",
    margin: "0 0 20px 0",
  },
  modulosGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "20px",
  },
  moduloCard: {
    border: "2px solid",
    borderRadius: "12px",
    padding: "20px",
    transition: "all 0.3s ease",
  },
  moduloHeader: {
    display: "flex",
    gap: "15px",
    marginBottom: "15px",
  },
  moduloIcon: {
    fontSize: "36px",
  },
  moduloTitulo: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0 0 5px 0",
  },
  moduloDescripcion: {
    fontSize: "13px",
    color: "#64748b",
    margin: "0",
    lineHeight: "1.4",
  },
  moduloEstado: {
    marginBottom: "15px",
  },
  estadoBadge: {
    display: "inline-block",
    padding: "6px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
  },
  btnToggle: {
    width: "100%",
    padding: "12px",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    color: "white",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#475569",
    marginBottom: "6px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  input: {
    padding: "10px 12px",
    fontSize: "14px",
    border: "1px solid #cbd5e1",
    borderRadius: "8px",
    outline: "none",
    transition: "all 0.2s ease",
  },
  checkbox: {
    width: "18px",
    height: "18px",
    cursor: "pointer",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
  },
  btnGuardar: {
    padding: "12px 32px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "600",
    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
    transition: "all 0.2s ease",
  },
};

export default Configuracion;